// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"206":"a85641de","646":"a85641de","663":"f8cbf567"}[chunkId] + ".css";
};